<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  name: "JobsList",
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="smart-group">
    <div class="container">
      <h2>Democratizar o fitness de alto padrão</h2>
      <p>
        A Smart Fit surgiu com o propósito de democratizar o acesso à prática de
        exercícios físicos. E sua inquietude fez com que ao longo dos anos ela
        se transformasse em um grande ecossistema de soluções, para que as
        pessoas possam levar uma vida mais ativa e saudável, em qualquer lugar e
        sempre pagando um preço justo.
      </p>
    </div>
    <div class="bg"></div>
    <div class="container inscritions">
      <h2 class="text-center">
        Inscreva-se no <br />
        Banco de Talentos da Smart Fit:
      </h2>

      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/vaga1.jpg" alt="" />
            </div>
            <div class="text">
              <h3>RECEPCIONISTA</h3>
              <router-link
                :to="'/vagas/143235-smart-fit-banco-de-talentos-recepcionista/inscricao'"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 mt-4 mt-md-0">
          <div class="inscritions_card">
            <div class="img with-border-bottom">
              <img src="@/assets/images/smart_fit/vaga2.jpg" alt="" />
            </div>
            <div class="text">
              <h3>AUXILIAR DE MANUTENÇÃO</h3>
              <router-link
                to="/vagas/143534-smart-fit-banco-de-talentos-auxiliar-de-manutencao/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/vaga3.jpg" alt="" />
            </div>
            <div class="text">
              <h3>PROFESSOR DE MUSCULAÇÃO</h3>
              <router-link
                to="/vagas/143535-smart-fit-banco-de-talentos-professor-de-musculacao/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/vaga4.jpg" alt="" />
            </div>
            <div class="text">
              <h3>PROFESSOR DE GINÁSTICA</h3>
              <router-link
                to="/vagas/143541-smart-fit-banco-de-talentos-professor-de-ginastica/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.inscritions {
  .row {
    width: 70%;
    margin: 0 auto;
    margin-top: 3rem;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }
}

.inscritions_card {
  background: #ffffff;
  box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  border-top: 6px solid theme-color(primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .text {
    width: 100%;
    padding: 2rem 4rem;
    text-align: center;
    min-height: 200px;
  }
  h3 {
    font-weight: bold;
    height: 90px;
  }
  a {
    text-align: center;
    background-color: #000;
    color: #fff;
    font-size: 1.6rem;
    font-weight: 300;
    width: 100%;
    display: block;
    padding: 0.5rem 1rem;
    transition: all 0.2s ease-in-out;
    &:hover {
      background-color: theme-color(primary);
    }
  }
  .img {
    height: 200px;
    overflow: hidden;

    &.with-border-bottom{
      border-bottom: 2px solid theme-color(primary);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.smart-group {
  margin: 6rem 0px 5rem 0px;
  p {
    font-size: 1.8rem;
    color: #000;
    line-height: calc(1.8rem * 1.2);
  }
  .bg {
    height: 600px;
    overflow: hidden;
    background: url(../../assets/images/smart_fit/jobsmart.jpg) no-repeat center;
    background-size: cover;
    margin-top: 3rem;
    @include media-breakpoint-down(sm) {
      height: 300px;
    }
  }
  .inscritions {
    padding: 5rem 0px;
    h2 {
      font-size: 4.3rem !important;
      font-family: "Gotham HTF" !important;
      @include media-breakpoint-down(sm) {
        font-size: 2rem !important;
      }
    }
  }
}
</style>